// removed by extract-text-webpack-plugin
module.exports = {"item":"ParagraphFullText-module-item-3SvTm"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalDocument/components/ParagraphFullText/ParagraphFullText.module.scss
// module id = 1310
// module chunks = 0